export default "__VITE_ASSET__CXoscFSX__"